import { CommonStateEnum } from "./common";
import { OrderItem } from "./inventory";
import { OrderItemV2 } from "./inventoryV2";
import { Product } from "./product";
import { QuotationRequest, Requirement, RequirementItem } from "./requirement";
import { User } from "./user";

export interface SupplierAdd {
  code: string; // not null, 客户编号
  name: string; // nullable, 客户名称1
  shortName?: string; // nullable, 客户简称
  country?: string; // nullable, 客户国籍/区域
  address?: string; // nullable, 客户地址
  zipCode?: string; // nullable, 客户邮编
  email?: string; // nullable, 客户电子邮箱
  contact?: string; // nullable, 联系人
  phone?: string; // nullable, 联系电话
  mobile?: string; // nullable, 联系手机
  fax?: string; // nullable, 传真
  account1?: string; // nullable, 开户银行1
  bank1?: string; // nullable, 银行帐号1
  swiftCode1?: string; // nullable, 银行编码1
  account2?: string; // nullable, 开户银行2
  bank2?: string; // nullable, 银行帐号2
  swiftCode2?: string; // nullable, 银行编码2
  currency?: string; // nullable, 币种
  creditLevel?: string; // nullable, 信用等级
  creditLine?: string; // nullable, 信用额度
  depositRate?: string; // nullable, 定金比例
  tradeTerm?: string; // nullable, 贸易条款
  payMethod?: string; // nullable, 付款方式
  affiliates?: string; // nullable, 关联公司
  orgId?: string; // nullable, 分管部门
  taxRate?: string; // 税率
  billingDays?: string;
  principal?: string; //
  wmsApi?: string; //供应商api
  thdCode?: string; //供应商mes编码
  mpq?: string; //最小包装
}

export interface Supplier extends SupplierAdd {
  id: string;
  docId: string; // not null, 文档ID
  currencyCopy?: string,
  currencyRate?: number
  creator?: User;
}

export interface SupplierPriceAdd {
  productId: string;
  price: string;
  remark: string;
  effectiveAt: number;
  expiredAt: number;
  ladders: Array<SupplierLadderPriceAdd>;
  days: number | null;
  mpq: string | null;
  code?: string | null;
  name?: string | null;
  priceId?: string;
  docId?: string;
  picDocId?: string;
  currency?: string;
  address?: string;
  spareRate?: string;
  taxRate?: string; // 税率
  brand?: string | null; // 品牌
  mpn?: string | null; // 原厂代码
  dcc?: string; // 保质期
  netWeight?: string | null; // 净重
  grossWeight?: string | null; // 毛重
}

export interface SupplierPriceRequestAdd extends SupplierPriceAdd {
  supplierId: string;
  approveState?: SupplierApprovePriceStateEnum | null;
}

export interface SupplierPrice extends SupplierPriceAdd {
  id: string;
  supplierId: string;
  product: Product;
  supplier: Supplier;
  ladders: Array<SupplierLadderPrice>;
  priceState: CommonStateEnum;
  priceId: string;
  address: string;
  currency: string;
  createdAt: number;
  standPrice: SupplierPrice | null;
}

export enum SupplierPriceStateEnum {
  UN_PRICED = 0,
  PRICED = 1,
}
export enum SupplierApprovePriceStateEnum {
  REJECTED = 0,
  RESOLVED = 1,
}
export interface SupplierApprovePrice extends SupplierPrice {
  state: SupplierPriceStateEnum;
  approveState: SupplierApprovePriceStateEnum | null;
  logBookId: string;
  docId: string;
  picDocId: string;
  currency: string;
}

export interface ProductSupplierPrice {
  id: string;
  product: Product;
  priceRequest: SupplierApprovePrice | null;
}

export interface SupplierLadderPriceAdd {
  count: number;
  price: string;
  discount: string;
  remark: string;
}

export interface SupplierLadderPrice extends SupplierLadderPriceAdd {
  id: string;
  standardHisId: string;
  ladderId: string;
}

export interface PurchaseOrderAddItem {
  type: number;
  sourceId?: string; // 销售订单来源
  priceId: string;
  count: number;
  amount: string;
  rateAmount: string;
  remark: string;
  scheduledOrderTime: number | null;
  deliveryDeadline: number | null;
  estimateArrivalAt: number | null;
  deliveredQuantity: number; // 已送达数量, 默认 0
  taxRate: string;
  orderState?: PurchaseOrderStateEnum;
  orderTime?: number | null;
  otherNumber1?: string;
}

export enum PurchaseOrderStateEnum {
  PAY_PENDING, // 未下单 - 0
  PAYED, // 已下单 - 1
  DONE, // 已完成 - 2
  COMPLETED, //完结 - 3
}

export interface PurchaseOrderAdd {
  amount: string;
  rateAmount: string;
  remark: string;
  supplierId: string;
  items: Array<PurchaseOrderAddItem>;
  currency: string;
  payMethod: string;
  receiver?: string;
  receiverAddress?: string;
  receiverContact?: string;
  receiverMobile?: string;
  acceptState?: AcceptStateEnum;
  sourceOrder?: string | null;
  sourceServer?: string | null;
}

export interface PurchaseRequirementItem extends RequirementItem {
  requirement: Requirement
}
export interface PurchaseQuotationRequest extends QuotationRequest {
  requirementItem: PurchaseRequirementItem
}

export enum PurchasefFnishStateEnum {
  UN_FINISHED = 0,
  FINISHING = 1,
  FINISHED = 2,
}

export enum PurchasefInStateEnum {
  UN_ARRIVED = 0, // 未到货
  PARTIAL_IN = 1, // 部分到货
  ALL_IN = 2, // 全部到货
}

export interface PurchaseOrderItem {
  inventoryOrders: Array<InventoryOrdersItem>;
  inventoryItems: Array<OrderItemV2> | null;
  id: string;
  state?: CommonStateEnum;
  createdAt: number;
  updatedAt: number;
  creator: null | User;
  updater: null | User;
  number: string;
  type: number;
  priceId: string; // 阶梯价的id
  taxRate: string;
  count: number; // 数量
  amount: string; // 未税总价
  rateAmount: string; // 含税总价
  orderState: PurchaseOrderStateEnum; // 已下单 - 1 与 未下单 - 0, 已完成 - 2
  orderTime: number | null; // 下单时间
  scheduledOrderTime: number | null; // 预计下单时间<最晚>
  deliveryDeadline: number | null; // 要求送货时间
  deliveredQuantity: number; // 已送达数量, 默认 0
  estimateArrivalAt: number | null; // 预计到货时间
  productId: string;
  remark: string;
  logBookId: string;
  docId: string;
  order: PurchaseOrder;
  orderId: string;
  price: PurchaseOrderItemPrice;
  priceStr: string;
  product: Product | null;
  printItem: PurchasePrintItem | null;
  quotationRequest: PurchaseQuotationRequest | null;
  equotationRequest: PurchaseQuotationRequest | null;
  spareCount: number;
  spareRate: string;
  finishState: PurchasefFnishStateEnum;
  inState: PurchasefInStateEnum;
  returnCount: number;
  brand?: string | null; // 品牌
  mpn?: string | null; // 原厂代码
  dcc?: string; // 保质期
  netWeight?: string | null; // 净重（kg）
  grossWeight?: string | null; // 毛重（kg）
  otherNumber1: string;
  otherNumber2: string;
  otherNumber3: string;
  otherNumber4: string;
  otherNumber5: string;
}

export interface Item {
  quantity: number;
}
export interface InventoryOrdersItem {
  forEach(arg0: (item: any) => void): unknown;
  inventoryOrders: Array<Item>;
  number: string;
  items: Array<OrderItem>;
}

export interface Item {
  quantity: number;
}
export interface InventoryOrdersItem {
  forEach(arg0: (item: any) => void): unknown;
  inventoryOrders: Array<Item>;
  number: string;
  confirmed: number;
}

export enum AcceptStateEnum {     //null是处理中
  RESOLVED = 1,
  REJECTED = 0
}

export interface PurchaseOrder {
  product: Product | null;
  count: number;
  inventoryOrders: InventoryOrdersItem;
  id: string;
  state: CommonStateEnum;
  createdAt: number;
  updatedAt: number;
  creator: null;
  updater: null;
  amount: string; // 订单的总价
  rateAmount: string; // 订单的总税额
  supplierId: string;
  remark: string;
  supplier: Supplier;
  currency: string;
  payMethod: string;
  items: Array<PurchaseOrderItem> | null;
  acceptState: AcceptStateEnum;
  acceptedAt: string;
  acceptor: User;
  receiver?: string;
  receiverAddress?: string;
  receiverContact?: string;
  receiverMobile?: string;
  sourceServer: string | null;
  sourceOrder: string | null;
}

export interface PurchaseOrderItemPrice {
  id: string;
  standardHisId: string;
  ladderId: string;
  count: number;
  discount: string;
  price: string;
  remark: string;
  product: Product | null;
  standardPrice: PurchaseOrderItemStandardPrice | null;
}

export interface PurchaseOrderItemStandardPrice {
  id: string;
  priceId: string;
  supplierId: string;
  productId: string;
  price: string;
  expiredAt: number | null;
  remark: string;
}

export interface PurchasePrintAdd {
  supplierId: string;
  fileId: string;
  desc: string;
  items: Array<PurchasePrintAddItem>;
}

export interface PurchasePrintAddItem {
  purItemId: string;
  desc: string;
}

export interface PurchasePrintItem {
  desc: string;
  id: string;
  purItemId: string;
  order: {
    fileId: string;
    id: string;
  };
}

export interface PurchasePrint {
  desc: string;
  file: null;
  fileId: string;
  id: string;
  items: Array<PurchasePrintItem>;
  supplier: null;
  supplierId: string;
}

export interface BatchInOrderAddItem {
  purItemId: string;
  sioOrderItem: string;
  produceCode: string;
  totalCount: number;
  inCount: number;
  purCount: number;
  remainCount: number;
}
export interface BatchInOrderAdd {
  supplierId: string;
  fileId: string;
  items: Array<BatchInOrderAddItem>
}
